import { Box, Typography, IconButton, Divider } from "@mui/material";
import PrintRounded from "@mui/icons-material/PrintRounded";
import { useTranslation } from "react-i18next";
import { PRODUCT_INFO } from "../../../locales/components/namespaces";
import XMuiIcon from "@mui/icons-material/X";
import InstagramIcon from '@mui/icons-material/Instagram';

function FacebookSvg({ size = 18, color = "#111", ...props }) {
  return (
    <svg
      viewBox="0 0 21 25"
      width={size}
      height={size}
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <path
        d="M14.18 8.5h-1.23c-.96 0-1.15.46-1.15 1.14V11h2.34l-.31 2.4h-2.03v6.16h-2.47V13.4H7.5V11h1.83V9.4c0-1.81 1.1-2.93 2.9-2.93.83 0 1.55.06 1.95.09v2.04Z"
        fill={color}
      />
    </svg>
  );
}

function InstaSvg({ size = 18, color = "#111", ...props }) {
  return (
    <InstagramIcon
      {...props}
      sx={{
        fontSize: size,
        color,
        ...props.sx,
      }}
    />
  );
}

export default function ProductShareRow({ onPrint, onShareFacebook, onShareInsta }) {
  const { t } = useTranslation(PRODUCT_INFO);
  const buttonStyle = {
    width: 40,
    height: 40,
    bgcolor: "#FFFFFF",
    border: "1px solid #E0E0E0",
    borderRadius: "20px",
    p: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto",
    "&:hover": { bgcolor: "#FFFFFF" },
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        mt: 4,
        flexWrap: "wrap",
        minWidth: 0,
      }}
    >
      <IconButton aria-label="Εκτύπωση" onClick={onPrint} sx={buttonStyle}>
        <PrintRounded sx={{ color: "#111", fontSize: 18 }} />
      </IconButton>

      <Divider
        orientation="vertical"
        flexItem
        sx={{
          mx: 1.5,
          borderColor: "#8D8D8D",
          display: { xs: "none", sm: "block" },
        }}
      />

      <Typography
        sx={{
          color: "#111",
          fontSize: 14,
          fontWeight: 500,
          whiteSpace: "nowrap",
          wordBreak: "keep-all",
          flex: "0 1 auto",
        }}
      >
        {t("share")}
      </Typography>

      <IconButton
        aria-label="Facebook"
        onClick={onShareFacebook}
        sx={buttonStyle}
        size="small"
      >
        <FacebookSvg size={27} color="#111" />
      </IconButton>

      <IconButton aria-label="X" onClick={onShareInsta} sx={buttonStyle} size="small">
        <InstaSvg size={20} color="#111" />
      </IconButton>
    </Box>
  );
}
